import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import Icon from '../../atoms/Icon'
import DenaliActionMenu from '../../organisms/DenaliActionPipeline/triggers/DenaliActionMenu'

/**
 * Represents an individual activity item that is non-specific
 * @param activity
 * @param onClick
 * @param actions
 * @param className
 * @param style
 * @returns {JSX.Element}
 * @constructor
 */
function Activity ({ activity, onClick, actions, className, style }) {
  return (
    <div className={clsx(className, 'flex flex-row gap-sm items-center')} style={style}>
      <div className='flex flex-row gap-sm clickable flex-1' onClick={onClick}>
        <div>
          <Icon name={activity.completed ? 'checkCircle' : 'clock'} style={{ fill: activity.completed ? 'var(--color-success-500)' : 'var(--color-warning-500)' }} />
        </div>
        <div>
          {activity.subject}
        </div>
      </div>
      {actions?.length ? (
        <DenaliActionMenu size='16px' actions={actions} subject={activity} />
      ) : null}
    </div>
  )
}

Activity.propTypes = {
  activity: PropTypes.shape({
    subject: PropTypes.string,
    completed: PropTypes.bool
  }).isRequired,
  actions: PropTypes.array,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object
}

export default Activity
